import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";
import "./Faq.css";

import Linkedinicon from "../../../assets/logo/linkedin.webp";
import Whatsappicon from "../../../assets/logo/whatsapp.png";
import Instagram from "../../../assets/logo/instagram.webp";
const faqData = [
  {
    question: "How to become an IHN Member?",
    answer:
      "IHN – Indian Hospitality Network is a private network platform that helps industry professionals connect for business networking. For more details, connect with us via WhatsApp, LinkedIn or Instagram."
  },
  {
    question: "What is the vision & mission of IHN?",
    answer:
      "Indian Hospitality Network (IHN) envisions creating a unified, future-ready ecosystem that elevates Indian hospitality on the global stage. We aim to move beyond traditional networking by fostering meaningful collaboration among professionals, brands, and industry stakeholders. Our mission is to empower the hospitality sector through precision networking and strategic connections across travel, events, weddings, tourism, and allied verticals. By enabling curated synergies and personalized “Dream Connects,” IHN drives sustainable growth rooted in trust, innovation, and long-term impact."
  },
  {
    question: "What are the membership benefits at IHN?",
    answer:
      "Members get regular engagement through city chapters, virtual meetings, and curated business connects to enable collaborations and growth."
  }
];

const FAQItem = ({ question, answer, isOpen, onClick, index }) => {
  return (
    <div className={`faq-item ${isOpen ? "active" : ""}`}>
      <button className="faq-button" onClick={onClick}>
        <span>{question}</span>
        <motion.div animate={{ rotate: isOpen ? 180 : 0 }}>
          <ChevronDown size={20} />
        </motion.div>
      </button>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="faq-answer-wrapper"
          >
            <p className="faq-answer">{answer}</p>

            {/* Logic: Only show icons for the first item (index 0) */}
            {index === 0 && (
              <div className="faq-social-icons">
                <a
                  href={`https://wa.me/+919810044015`}
                  target="_blank"
                  rel="noopener noreferrer"
                  title="WhatsApp"
                >
                  <img src={Whatsappicon} alt="WhatsApp" className="social-logo" />
                </a>
                <a
                  href="https://www.linkedin.com/company/indianhospitalitynetwork/"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="LinkedIn"
                >
                  <img src={Linkedinicon} alt="LinkedIn" className="social-logo" />
                </a>
                <a href="https://www.instagram.com/indianhospitalitynetwork/" target="_blank" rel="noreferrer">
                  <img src={Instagram} className="social-logo" alt="insta" />
                </a>
              </div>
            )}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <div className="faq-container">
      <h2 className="faq-title ">Frequently Asked Questions</h2>

      {faqData.map((item, index) => (
        <FAQItem
          key={index}
          index={index} // Passing the index to the component
          {...item}
          isOpen={openIndex === index}
          onClick={() => setOpenIndex(openIndex === index ? null : index)}
        />
      ))}
    </div>
  );
}
